<template>
    <div class="page-campaign">

        <FormMessage
            v-if="error_message"
            :message="error_message"
            @hideMessage="error_message = null"
            ref="error"
        />


        <div class="page-content">
            <header class="page-header">
                <div class="page-header-logo">
                    <img
                        src="@/assets/images/business_and_food_lovers_club.svg"
                        alt="Business & Food Lovers Club"
                    />
                </div>
                <div class="page-header-image" />
                <div
                    v-if="campaign && campaign.logoImage && campaign.logoImage.thumbnails[0]"
                    class="page-campaign-company-logo"
                >
                    <img :src="campaign.logoImage.thumbnails[0].url" :alt="campaign.name" />
                </div>
            </header>

            <transition name="fade">
                <div v-if="formIsDone">
                    <CampaignDone />
                </div>

                <div v-else class="page-campaign-body">
                    <!--<form @submit.prevent="NipSubmit">
                        <section class="typo">
                            <h2>
                                NIP Twojego Pracodawcy
                            </h2>

                            <FormInput
                                name="nip"
                                v-model="form.nip"
                                mask='###-###-##-##'
                                :valid="nipError ? false : (validNip ? true : null)"
                                :disabled="loadingNipCheck || validNip"
                                @input="onNipInput"
                            />


                            <div class="text-center" v-if="!validNip">
                                <FormSubmit
                                    label="Przejdź do rejestracji"
                                    :loading="loadingNipCheck"
                                />
                            </div>
                        </section>
                    </form>-->

                    <transition name="fade">
                        <form v-if="campaign && validNip" @submit.prevent="FormSubmit">

                            <section class="typo">
                                <hr />
                                <h2>
                                    Wpisz swoje dane do rejestracji karty MAKRO
                                </h2>
                                <FormInput
                                    name="firstName"
                                    label="Imię"
                                    ref="form_firstName"
                                    v-model="form.firstName"
                                    required
                                    :disabled="loadingFormSubmit"
                                    :valid="errors.firstName ? false : null"
                                    @input="errors.firstName = false"
                                />
                                <FormInput
                                    name="lastName"
                                    label="Nazwisko"
                                    ref="form_lastName"
                                    v-model="form.lastName"
                                    required
                                    :disabled="loadingFormSubmit"
                                    :valid="errors.lastName ? false : null"
                                    @input="errors.lastName = false"
                                />

                                <div class="page-campaign-grid">

                                    <div class="col-3">
                                        <FormInput
                                            name="phoneNumber"
                                            label="Numer telefonu"
                                            ref="form_phoneNumber"
                                            type="tel"
                                            v-model="form.phoneNumber"
                                            required
                                            mask='###-###-###'
                                            :disabled="loadingFormSubmit"
                                            :valid="errors.phoneNumber ? false : null"
                                        />
                                        <FormInput
                                            name="email"
                                            label="E-mail"
                                            ref="form_email"
                                            type="email"
                                            v-model="form.email"
                                            required
                                            :disabled="loadingFormSubmit"
                                            :valid="errors.email ? false : null"
                                            @input="errors.email = false"
                                        />
                                    </div>

                                    <div class="col-2">
                                        <div class="text-center" style="margin-bottom: 20px;">
                                            <div style="margin-bottom: 10px;">
                                                <label
                                                    @click="$refs.rodo1.toggle()"
                                                    class="form-input-label"
                                                >
                                                    Zgody na komunikację
                                                </label>
                                            </div>
                                            <FormToggle
                                                name="phoneNumberMarketingContactAgreement"
                                                v-model="form.phoneNumberMarketingContactAgreement"
                                                ref="rodo1"
                                                :disabled="loadingFormSubmit"
                                            />
                                        </div>
                                        <div class="text-center">
                                            <div style="margin-bottom: 10px;">
                                                <label
                                                    @click="$refs.rodo2.toggle()"
                                                    class="form-input-label"
                                                >
                                                    <small v-bastards style="font-size: 12px;">
                                                        Chcę otrzymywać kupony rabatowe
                                                        i informacje o najnowszych promocjach.
                                                    </small>
                                                </label>
                                            </div>
                                            <FormToggle
                                                name="emailMarketingContactAgreement"
                                                v-model="form.emailMarketingContactAgreement"
                                                ref="rodo2"
                                                :disabled="loadingFormSubmit"
                                            />
                                        </div>
                                    </div>

                                </div>
                            </section>

                            <CampaignInfo />

                            <section class="typo">

                                <hr />
                                <h2>
                                    Adres najbliższej hurtowni
                                </h2>
                                <p v-bastards>
                                    <strong>Ważna informacja:</strong>
                                    Wszystkie formalności związane ze swoją kartą,
                                    dopełnisz w zaznaczonej poniżej hali MAKRO.
                                </p>

                                <FormHall
                                    v-model="form.hall"
                                    :disabled="loadingFormSubmit"
                                    :invalid="errors.hall"
                                    @input="errors.hall = false"
                                />

                                <p>
                                    <FormToggle
                                        name="acceptanceOfRegulations"
                                        v-model="form.acceptanceOfRegulations"
                                        ref="terms"
                                        :disabled="loadingFormSubmit"
                                        :invalid="errors.acceptanceOfRegulations"
                                        @input="errors.acceptanceOfRegulations = false"
                                    />
                                </p>
                                <p @click="$refs.terms.toggle()" style="cursor:pointer;" v-bastards>
                                    Oświadczam, że zapoznałem się z Regulaminem Klienta MAKRO,
                                    dostępnym w hali MAKRO i na www.makro.pl.
                                </p>
                            </section>

                            <div class="page-campaign-action">
                                <FormSubmit
                                    label="Wyślij rejestrację"
                                    :loading="loadingFormSubmit"
                                />
                            </div>
                        </form>
                    </transition>
                </div>
            </transition>
        </div>



        <CampaignBackground />
        <div class="page-campaign-footer-logo">
            <img
                class=""
                src="~@/assets/images/corner_logo.svg"
                alt="Makro - Twój sukces to nasz biznes"
            />
        </div>
    </div>
</template>

<script>
    import FormInput from '@/components/form/FormInput'
    import CampaignBackground from '@/components/page/campaign/CampaignBackground'
    import CampaignInfo from '@/components/page/campaign/CampaignInfo'
    import FormToggle from '@/components/form/FormToggle'
    import FormHall from '@/components/form/FormHall'
    import FormSubmit from '@/components/form/FormSubmit'

    import ApiMakro from '@/api/ApiMakro'
    import VueScrollTo from 'vue-scrollto'
    import CampaignDone from '@/components/page/campaign/CampaignDone'
    import FormMessage from '@/components/form/FormMessage'
    import gtmHit from '@/gtm'
    import { mapGetters } from 'vuex'

    export default {
        name: "Campaign",
        components: {
            FormMessage,
            CampaignDone, FormSubmit, FormHall, FormToggle, CampaignInfo, FormInput, CampaignBackground },
        props: {
            slug: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                loadingCampaign: true,
                loadingNipCheck: false,
                loadingFormSubmit: false,
                campaign: {},
                nipError: false,
                validNip:  true, // set to false to enable nip check
                formIsDone: false,
                error_message: null,
                form: {
                    id: '',
                    acceptanceOfRegulations: false,
                    phoneNumberMarketingContactAgreement: false,
                    emailMarketingContactAgreement: false,
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    email: '',
                    hall: null,
                    // nip: ''
                },
                errors: {
                    acceptanceOfRegulations: false,
                    // phoneNumberMarketingContactAgreement: false,
                    // emailMarketingContactAgreement: false,
                    firstName: false,
                    lastName: false,
                    phoneNumber: false,
                    email: false,
                    hall: false
                }
            }
        },
        computed: {
            ...mapGetters({
                cookiesTypes: 'getCookiesTypes'
            }),
            cookiesAdvertisingAllowed() {
                return this.cookiesTypes && this.cookiesTypes.advertising
            }
        },
        mounted() {
            ApiMakro.getCampaign(this.slug).then(response => {
                this.campaign = response.data
                this.form.id = this.campaign.id

                if (this.cookiesAdvertisingAllowed) {
                    gtmHit(this, {
                        url: this.$route.fullPath,
                        templateType: 'campaign',
                        seoTitle: `Makro rejestracja`
                    })
                }
            }).catch(() => {
                if (this.cookiesAdvertisingAllowed) {
                    gtmHit(this, {
                        url: this.$route.fullPath,
                        templateType: 'error',
                        seoTitle: `Makro rejestracja`,
                        errorPage: 'errorpage',
                        statusCode: 404
                    })
                }

                this.error = true
                this.$router.push('/error/404')
            }).finally(() => {
                this.loadingCampaign = false
                setTimeout(() => {
                    this.$store.commit('setLoading', false)
                }, 800)
            })
        },
        methods: {
            /**
             * Submit Nip form
             *
             */
            NipSubmit () {
                if (this.loadingNipCheck) {
                    return
                }
                console.log('nip submit', this.form.nip)

                this.nipError = false
                if (!this.validateNip(this.form.nip)) {
                    this.nipError = true
                    return
                }
                this.$refs.error && this.$refs.error.close();
                this.loadingNipCheck = true
                ApiMakro.getCampaign(this.formatNip(this.form.nip)).then(response => {
                    if (response.data.id === this.campaign.id) {
                        this.validNip = true
                        this.form.id = this.campaign.id
                    } else {
                        this.nipError = true
                        this.error_message = 'Nieprawidłowy numer NIP.';
                    }
                }).catch(() => {
                    this.nipError = true
                    this.error_message = 'Nieprawidłowy numer NIP.';
                }).finally(() => {
                    this.loadingNipCheck = false
                })
            },
            /**
             * Submit Form
             *
             */
            FormSubmit () {
                if (this.loadingFormSubmit) {
                    return
                }
                console.log('form submit', this.form)

                if (!this.validateForm()) {
                    VueScrollTo.scrollTo('#app', 800);
                    this.error_message = 'Uzupełnij poprawnie wszystkie zaznaczone pola.'
                    return
                }
                this.$refs.error && this.$refs.error.close();
                this.loadingFormSubmit = true
                let payload = Object.assign({}, this.form)
                // payload.nip = this.formatNip(this.form.nip)
                payload.phoneNumber = this.formatTel(this.form.phoneNumber)
                ApiMakro.submitCard(payload).then(() => {
                    this.formIsDone = true
                    VueScrollTo.scrollTo('#app', 800);
                }).catch(() => {
                    // TODO error info ?
                    this.error_message = 'Wystąpił błąd przy zgłoszeniu formularza. Upewnij się że wszystkie pola są poprawnie wypełnione i ponów próbę.'
                }).finally(() => {
                    this.loadingFormSubmit = false
                })

                // setTimeout(() => {
                //     this.loadingFormSubmit = false
                // }, 3000)

            },
            /**
             * On nip input event
             */
            onNipInput () {
                this.nipError = false
            },
            /**
             * Format NIP number
             * remove non digit chars
             *
             * @param {string} nip
             */
            formatNip (nip) {
                return nip.replace(/[^0-9.]/g, '').trim()
            },
            /**
             * Format Phone number
             * remove non digit chars
             */
            formatTel (tel) {
                return tel.replace('+48', '').replace(/[^0-9.]/g, '').trim()
            },
            /**
             * Validate form
             *
             * @returns {boolean}
             */
            validateForm () {
                let errors = 0
                // TODO move validation to input components
                const inputs = ['firstName', 'lastName', 'phoneNumber', 'acceptanceOfRegulations', 'email', 'hall']

                inputs.forEach(input => {
                    const value = this.form[input]
                    if (!value) {
                        this.errors[input] = true
                        errors++
                    }
                    let $input = this.$refs['form_' + input]
                    if ($input) {
                        if ($input.type === 'email' && !this.validateEmail(value)) {
                            this.errors[input] = true
                            errors++
                        }
                        if ($input.type === 'tel' && !this.validatePhone(value)) {
                            this.errors[input] = true
                            errors++
                        }
                    }

                })

                return errors === 0
            },
            /**
             * Validate NIP
             * @param {string} entryNip
             * @returns {boolean}
             */
            validateNip(entryNip) {
                let nip = entryNip.replace(new RegExp("-", 'g'), '').trim()
                return /^\d+$/.test(nip) && nip.length === 10
            },
            /**
             * Validate Email
             *
             * @param email
             * @returns {boolean}
             */
            validateEmail(email) {
                // let standardRegex = /^(\w+[-.])*\w+@(\w+[-.])+[A-Za-z]+$/
                // let regex = /^[a-zA-Z0-9]+[+]?[_.a-zA-Z0-9-]*@(?!-)+[a-zA-Z0-9-]+.[a-zA-Z0-9]{2,}$/
                const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return regex.test(email)
            },
            /**
             * Validate phone
             *
             * @param phone
             * @returns {boolean}
             */
            validatePhone(phone) {
                let regex = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/
                if (/^\+/.test(phone)) {
                    if (/^\+48/.test(phone)) {
                        regex = /^\+48[\s0-9-]{9,}$/
                    } else {
                        regex = /^\+[\s0-9-]{11,}$/
                    }
                }
                if (/^0/.test(phone)) {
                    if (/^0048/.test(phone)) {
                        regex = /^0048[\s0-9-]{9,}$/
                    } else {
                        regex = /^0[\s0-9-]{12,}$/
                    }
                }
                return regex.test(phone)
            }/*,

            updateTel (tel) {
                this.errors.phoneNumber = false

                setTimeout(() => {
                    tel = this.formatTel(tel).substring(0,9)
                    this.form.phoneNumber = tel
                })
            }*/

        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/screen';

    .page-campaign {

        &-grid {
            display: grid;
            grid-template-columns: 3fr 2fr;

            @media (max-width: $screen-mobile) {
                grid-template-columns: 1fr;
            }
        }

        &-action {
            margin-top: 35px;
            text-align: center;
        }

        &-company {
            &-logo {
                margin: 50px 0 -10px;
                text-align: center;
                img {
                    max-width: 450px;
                    height: auto;
                }
            }
        }

        &-footer-logo {
            position: fixed;
            bottom: 0;
            right: 805px;
            width: 634px;
            height: 182px;
            vertical-align: bottom;
            z-index: 3;

            text-align: center;

            img {
                vertical-align: bottom;
                position: relative;
                bottom: -2px;
            }

            @media (max-width: 1420px) {
                right: 800px;
                width: auto;
                height: auto;
                left: 0;
                // width: 25%;
                // border: 1px solid red;
            }
            @media (max-width: 1240px) {
                /*width: 40%;*/
                /*transform: translateX(10%);*/
                // left: -10%;
            }
        }

        @media (max-width: $screen-mobile) {
            .page-header {
                margin-left: -10px;
                margin-right: -10px;
            }

        }
    }
</style>
